module.exports = __webpack_public_path__ + "img/logo.e833d0da.svg";